import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { SecondaryButton, InfoTooltip, Icon } from '../../components';

import css from './UploadButton.module.css';

const UploadButton = props => {
  const { titleMsgId, tooltipItems, disabled, onClick } = props;

  return (
    <div className={css.uploadContainer}>
      <h2 className={css.uploadTitle}>
        <FormattedMessage id={titleMsgId} />
        {tooltipItems ? <InfoTooltip items={tooltipItems} /> : null}
      </h2>
      <SecondaryButton
        className={css.uploadButton}
        type="button"
        disabled={disabled}
        onClick={onClick}
      >
        <Icon name="upload" size={16} className={css.uploadIcon} />
        <FormattedMessage id="EditListingGalleryForm.uploadImagesButton" />
      </SecondaryButton>
    </div>
  );
};

UploadButton.defaultProps = {
  disabled: false,
  onClick: null,
  tooltipItems: null,
};

const { arrayOf, bool, func, string } = PropTypes;

UploadButton.propTypes = {
  disabled: bool.isRequired,
  onClick: func.isRequired,
  tooltipItems: arrayOf(string),
};

export default UploadButton;
